import { PropsWithChildren } from 'react';

import { FeatureId } from '@/core/feature-flags/enums';

export interface Props {
  featureId?: FeatureId;
}

/**
 * Индикатор ограниченной функции. В ShbDeployer все функции доступны без ограничений,
 * поэтому компонент ничего не отображает. Сохранен для совместимости вызывающего кода.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function BEFeatureIndicator({ featureId }: PropsWithChildren<Props>) {
  return null;
}
